/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ProviderResponse = zod
	.object({
		url: zod.url().describe('OAuth provider URL')
	})
	.describe('OAuth provider redirect response');

export type ProviderResponse = zod.input<typeof ProviderResponse>;
export type ProviderResponseOutput = zod.output<typeof ProviderResponse>;
